import { useMemo } from 'react';
import * as MapGL from 'react-map-gl/mapbox';
import { useSnapshot } from 'valtio';
import { getColorFromRgb } from '../common';
import store from '../store';
import { isLine, isPoint, isPolygon, LINE_WIDTH, POINT_RADIUS } from './common';

const SELECTED_FEATURE_SOURCE = 'selected-feature-source';

export default function SelectedLayer() {
  const { selectedFeature, projectIntelligence } = useSnapshot(store) as typeof store;

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const content = useMemo(() => {
    if (!selectedFeature || !selectedFeature?.id?.toString()) {
      return null;
    }

    const featureId = selectedFeature.id?.toString();

    if (!featureId) return null;

    const item = projectIntelligence[featureId];
    const color = getColorFromRgb(item.rgb) || 'red';

    if (isLine(selectedFeature)) {
      return (
        <MapGL.Source id={SELECTED_FEATURE_SOURCE} type="geojson" data={selectedFeature}>
          <MapGL.Layer
            source={SELECTED_FEATURE_SOURCE}
            type="line"
            paint={{
              'line-color': color,
              'line-width': LINE_WIDTH * 4,
            }}
          />
        </MapGL.Source>
      );
    } else if (isPoint(selectedFeature)) {
      return (
        <MapGL.Source key={SELECTED_FEATURE_SOURCE} type="geojson" data={selectedFeature}>
          <MapGL.Layer
            source={SELECTED_FEATURE_SOURCE}
            type="circle"
            paint={{
              'circle-stroke-color': color || 'red',
              'circle-stroke-width': LINE_WIDTH * 3,
              'circle-radius': POINT_RADIUS * 1.5,
              'circle-color': 'transparent',
            }}
          />
        </MapGL.Source>
      );
    } else if (isPolygon(selectedFeature)) {
      return (
        <MapGL.Source id={SELECTED_FEATURE_SOURCE} type="geojson" data={selectedFeature}>
          <MapGL.Layer
            source={SELECTED_FEATURE_SOURCE}
            type="fill"
            paint={{
              'fill-color': color,
              'fill-opacity': 0.75,
            }}
          />
          <MapGL.Layer
            source={SELECTED_FEATURE_SOURCE}
            type="line"
            paint={{
              'line-color': color,
              'line-width': LINE_WIDTH,
            }}
          />
        </MapGL.Source>
      );
    }

    return null;
  }, [selectedFeature]);

  return <>{content}</>;
}
